import React from 'react';
import './Reverse.scss';
import './App.scss';
import './libs/fonts/fonts.scss';

import MainLayout from './containers/main-layout';
import UtagContextProvider from './context/UtagContext';
interface IAppProps {
  analytics: any[];
}

const App: React.FC<IAppProps> = ({ analytics }) => {

  return (
    <UtagContextProvider>
      <MainLayout analytics={analytics} />
    </UtagContextProvider>
  );
};

export default App;
